module.exports = __webpack_public_path__ + "assets/img/ijj_qrcode2.c190a3ce.jpg";